import React, { useState, useEffect, useCallback } from "react";
import { API } from "../services/config";
import "./ManageGastos.css";

export default function ManageGastos({ token, onClose, profesionalId }) {
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);

  const [formData, setFormData] = useState({
    categoria: "otro",
    descripcion: "",
    monto: "",
    fecha: new Date().toISOString().split("T")[0],
    responsable: "",
    notas: "",
  });

  const cargarGastos = useCallback(async () => {
    try {
      setLoading(true);
      const qs = profesionalId ? `?profesional_id=${profesionalId}` : "";
      const response = await fetch(`${API}/gastos${qs}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.success) {
        setGastos(data.data);
      }
    } catch (err) {
      console.error("Error al cargar gastos:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    cargarGastos();
  }, [cargarGastos]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      categoria: "otro",
      descripcion: "",
      monto: "",
      fecha: new Date().toISOString().split("T")[0],
      responsable: "",
      notas: "",
    });
    setEditando(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.descripcion.trim() || !formData.monto) {
      alert("Por favor completa descripción y monto");
      return;
    }

    try {
      const method = editando ? "PUT" : "POST";
      const url = editando
        ? `${API}/gastos/${editando.id}`
        : `${API}/gastos`;

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          profesional_id: profesionalId || null,
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert(editando ? "Gasto actualizado" : "Gasto creado");
        cargarGastos();
        resetForm();
        setMostrarForm(false);
      } else {
        alert("Error: " + (data.message || "No se pudo guardar"));
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const handleEdit = (gasto) => {
    setFormData({
      categoria: gasto.categoria,
      descripcion: gasto.descripcion,
      monto: gasto.monto,
      fecha: gasto.fecha,
      responsable: gasto.responsable || "",
      notas: gasto.notas || "",
    });
    setEditando(gasto);
    setMostrarForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este gasto?")) {
      return;
    }

    try {
      const response = await fetch(`${API}/gastos/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.success) {
        alert("Gasto eliminado");
        cargarGastos();
      } else {
        alert("Error al eliminar");
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const categoriaColors = {
    sueldo: "#f39c12",
    insumo: "#3498db",
    servicio: "#e74c3c",
    otro: "#7f8c8d",
  };

  const totalGastos = gastos.reduce((sum, g) => sum + parseFloat(g.monto || 0), 0);

  return (
    <div className="manage-gastos-modal">
      <div className="manage-gastos-contenido">
        <div className="manage-gastos-header">
          <h2>Gestión de Gastos</h2>
          <button className="manage-cerrar-x" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Botón para agregar */}
        {!mostrarForm && (
          <button
            className="manage-agregar-btn"
            onClick={() => {
              resetForm();
              setMostrarForm(true);
            }}
          >
            + Nuevo Gasto
          </button>
        )}

        {/* Formulario */}
        {mostrarForm && (
          <form className="manage-form" onSubmit={handleSubmit}>
            <h3>{editando ? "Editar Gasto" : "Nuevo Gasto"}</h3>

            <div className="form-group">
              <label>Categoría *</label>
              <select
                name="categoria"
                value={formData.categoria}
                onChange={handleChange}
                required
              >
                <option value="sueldo">Sueldo</option>
                <option value="insumo">Insumo</option>
                <option value="servicio">Servicio</option>
                <option value="otro">Otro</option>
              </select>
            </div>

            <div className="form-group">
              <label>Descripción *</label>
              <input
                type="text"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                placeholder="Ej: Sueldo Dr. Juan, Material dentales, etc"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Monto *</label>
                <input
                  type="number"
                  name="monto"
                  value={formData.monto}
                  onChange={handleChange}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  required
                />
              </div>

              <div className="form-group">
                <label>Fecha *</label>
                <input
                  type="date"
                  name="fecha"
                  value={formData.fecha}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Responsable</label>
              <input
                type="text"
                name="responsable"
                value={formData.responsable}
                onChange={handleChange}
                placeholder="Ej: Contador, Gerente, etc"
              />
            </div>

            <div className="form-group">
              <label>Notas</label>
              <textarea
                name="notas"
                value={formData.notas}
                onChange={handleChange}
                placeholder="Notas adicionales..."
                rows="2"
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-guardar">
                {editando ? "Actualizar" : "Crear"} Gasto
              </button>
              <button
                type="button"
                className="btn-cancelar"
                onClick={() => {
                  resetForm();
                  setMostrarForm(false);
                }}
              >
                Cancelar
              </button>
            </div>
          </form>
        )}

        {/* Total */}
        <div className="manage-total">
          <span>Total Gastos Registrados:</span>
          <span className="total-monto">
            ${totalGastos.toLocaleString("es-AR", { minimumFractionDigits: 2 })}
          </span>
        </div>

        {/* Lista de gastos */}
        {loading ? (
          <p className="manage-loading">Cargando...</p>
        ) : gastos.length > 0 ? (
          <div className="manage-lista">
            {gastos.map((gasto) => (
              <div key={gasto.id} className="manage-item">
                <div className="manage-item-info">
                  <div className="manage-item-header">
                    <span
                      className="manage-categoria"
                      style={{ backgroundColor: categoriaColors[gasto.categoria] }}
                    >
                      {gasto.categoria.toUpperCase()}
                    </span>
                    <span className="manage-descripcion">{gasto.descripcion}</span>
                  </div>
                  <div className="manage-item-detalles">
                    <span className="manage-fecha">
                      {new Date(gasto.fecha).toLocaleDateString("es-AR")}
                    </span>
                    {gasto.responsable && (
                      <span className="manage-responsable">{gasto.responsable}</span>
                    )}
                  </div>
                </div>

                <div className="manage-item-acciones">
                  <span className="manage-monto">
                    ${parseFloat(gasto.monto).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                  </span>
                  <button
                    className="manage-edit-btn"
                    onClick={() => handleEdit(gasto)}
                    title="Editar"
                  >
                    ✏️
                  </button>
                  <button
                    className="manage-delete-btn"
                    onClick={() => handleDelete(gasto.id)}
                    title="Eliminar"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="manage-vacio">No hay gastos registrados</p>
        )}

        <button className="manage-cerrar-btn" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
}
